import type { ComponentType } from "react";

import type { SvgIconProps } from "@mui/material";
import {
  SMART_CHECKOUT_ID,
  SMART_CONTENT_ID,
  SMART_MERCHANDISING_ID,
  SMART_PRICING_LIMITED_ID,
  SMART_PRICING_UNLIMITED_ID,
  SMART_SHIPPING_ID,
} from "@src/constants/billing";
import { CheckoutUngatedEmptyGraphic } from "@src/domains/experienceTablePages/CheckoutUngatedEmptyGraphic";
import { ContentUngatedEmptyGraphic } from "@src/domains/experienceTablePages/ContentUngatedEmptyGraphic";
import { MerchandisingUngatedEmptyGraphic } from "@src/domains/experienceTablePages/MerchandisingUngatedEmptyGraphic";
import { PricingUngatedEmptyGraphic } from "@src/domains/experienceTablePages/PricingUngatedEmptyGraphic";
import { ShippingUngatedEmptyGraphic } from "@src/domains/experienceTablePages/ShippingUngatedEmptyGraphic";
import { EXPERIENCE_ROUTES } from "@src/routes/routes";

interface TrialWelcomeModule {
  route: string;
  Graphic: ComponentType<SvgIconProps>;
}

export const TRIAL_WELCOME_MODULES: Record<string, TrialWelcomeModule> = {
  [SMART_CONTENT_ID]: {
    route: EXPERIENCE_ROUTES.Experiences_Content,
    Graphic: ContentUngatedEmptyGraphic,
  },
  [SMART_MERCHANDISING_ID]: {
    route: EXPERIENCE_ROUTES.Experiences_Merchandising,
    Graphic: MerchandisingUngatedEmptyGraphic,
  },
  [SMART_PRICING_LIMITED_ID]: {
    route: EXPERIENCE_ROUTES.Experiences_Pricing,
    Graphic: PricingUngatedEmptyGraphic,
  },
  [SMART_PRICING_UNLIMITED_ID]: {
    route: EXPERIENCE_ROUTES.Experiences_Pricing,
    Graphic: PricingUngatedEmptyGraphic,
  },
  [SMART_SHIPPING_ID]: {
    route: EXPERIENCE_ROUTES.Experiences_Shipping,
    Graphic: ShippingUngatedEmptyGraphic,
  },
  [SMART_CHECKOUT_ID]: {
    route: EXPERIENCE_ROUTES.Experiences_Checkout,
    Graphic: CheckoutUngatedEmptyGraphic,
  },
};
